<template>
  <section id="banner">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-7"></div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "Banner"
};
</script>
